import React from 'react';
import { Button, Typography } from '@mui/material';
import { KPI_CARD_COLOR } from 'src/colors';

const DemoButton = ({ dummyMarket }) => {
  return (
    <Button
      variant="outlined"
      onClick={() => {
        window.open(
          `/airbnb-data/${dummyMarket?.country}/${dummyMarket?.city}/${dummyMarket?.district}`,
          '_self'
        );
      }}
      sx={{
        border: `2px solid ${KPI_CARD_COLOR}`,
        color: KPI_CARD_COLOR,
        marginRight: '10px',
        borderRadius: '10px',
        '.MuiButton-outlined': { padding: '5px 8px !important' },
      }}
    >
      <Typography variant="body2">Demo Market</Typography>
    </Button>
  );
};

export default DemoButton;
